import { inject } from "@angular/core";
import { Router, ActivatedRouteSnapshot } from "@angular/router";
import { AuthenticationService } from "../shared/Services/authentication.service";

export const resetPasswordResolver = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  return auth.checkForgotPasswordKey(route.params['token']).subscribe({
    next: (res) => res,
    error: () => router.navigateByUrl('/login')
  });
};
